import $metrics from 'app/stores/metrics/$metrics';
import $devices from 'app/stores/device/$devices';

/**
 * @param {string} [device_name]
 * @param {string} [device_ip]
 * @param {string} [mac_address]
 * @returns {import('app/stores/device/DeviceModel').DeviceModel | undefined}
 */
export const getDeviceFromMetricsQueryModel = ({ device_name, device_ip, mac_address }) => {
  const name = $metrics.getMetricsDeviceNameFromQueryModel({ device_name, device_ip, mac_address });
  return $devices.byName(name);
};
